import type { Endpoints } from '~/types'
import type { RouteLocationNormalized } from '#vue-router'

export const useLoadWaper = () => {
  const wapersStore = useWapersStore()
  const rankingsStore = useRankingStore()

  return async (route: RouteLocationNormalized) => {
    const nickname = route.params.nickname as string

    if (!nickname) {
      throw createError({ statusCode: 404 })
    }

    await Promise.all([
      wapersStore.fetchWaper({
        nickname,
        isUser: false,
      }),
      rankingsStore.fetchTopWaper(nickname),
    ])

    if (!wapersStore.waper) {
      // a nickname changed for the Waper (it was an e-mail address): the former URL moves to the new one
      const { data } = await useCustomFetch<
        Endpoints['GET__USER_SLUG_REDIRECT']
      >(API.GET__USER_SLUG_REDIRECT.replace('$slug', nickname))
      const slug = unref(data)?.slug
      if (slug && slug !== nickname) {
        return navigateTo(`/wapers/${slug}`, { redirectCode: 301 })
      }
    }

    throwIfNotFound(wapersStore.waper)
  }
}
